import React from "react";
import { PrintHeader } from "./PrintHeader";

// Contenedor imprimible de un reporte: <PrintHeader> + contenido. Al imprimir
// es una <table> de verdad y la cabecera va en su <thead>, que Chrome repite
// en cada página. Tiene que ser una tabla HTML real: con <div> y
// display:table / table-header-group Chrome (probado en la 154) NO repite la
// cabecera. En pantalla, table/thead/tr/td se muestran como bloques, igual
// que el <div> de antes (ver .print-table en AdminLayout.scss).
export function PrintTable(props) {
  const { children } = props;
  const items = React.Children.toArray(children);
  const header = items.filter((child) => child.type === PrintHeader);
  const body = items.filter((child) => child.type !== PrintHeader);

  return (
    <table className="print-table">
      <thead>
        <tr>
          <td>{header}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{body}</td>
        </tr>
      </tbody>
    </table>
  );
}
